import * as React from "react";
import Button from "@material-ui/core/Button";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import Component from "../../../../AbstractComponent";
import PropertyLookup from "../../../../Partials/Lookup/PropertyLookup";

class Address extends Component {
  public state = {
    address: null,

    errors: {
      address: null,
    },
  };

  constructor(public props) {
    super(props);

    this.state = {
      address: this.props.state.address ?? null,

      errors: {
        address: null,
      },
    };

    this.onSelectAddress = this.onSelectAddress.bind(this);
    this.onClearAddress = this.onClearAddress.bind(this);
    this.validateStep = this.validateStep.bind(this);
    this.validateField = this.validateField.bind(this);
    this.onNextStep = this.onNextStep.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  public onSelectAddress(address) {
    this.setState({
      ...this.state,
      address: address,
    });
  }

  public onClearAddress() {
    this.setState({
      ...this.state,
      address: null,
    });
  }

  public validateField(field, value) {
    if (field === "address") {
      if (!value)
        return this.trans(
          "coach/new-bill-settlement/steps/address/errors/property-missing"
        );

      return null;
    }
  }

  public validateStep() {
    const newErrors = {};
    const fields = ["address"];

    for (const key of fields) {
      const error = this.validateField(key, this.state[key]);
      if (error) newErrors[key] = error;
    }

    return newErrors;
  }

  public onNextStep() {
    const newErrors = this.validateStep();

    if (Object.keys(newErrors).length > 0) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          ...newErrors,
        },
      });
      return;
    }

    this.props.setState({
      ...this.props.state,
      ...this.state,
      activeStep: 1,
    });
  }

  public onCancel() {
    this.props.onCancel();
  }

  public render() {
    return (
      <div className="coach_newBillSettlement_step_wrapper">
        <div className="coach_newBillSettlement_step_title">
          {this.trans(
            "coach/new-bill-settlement/steps/address/property-lookup-label"
          )}
        </div>
        <div className="coach_newBillSettlement_step_section_content">
          <div className="coach_newBillSettlement_step_section_content_item">
            <div className="coach_newBillSettlement_step_section_content_item_row">
              <PropertyLookup
                {...this.props}
                id="propertyId"
                name="propertyId"
                ref="PropertyLookup"
                className="scroll-to-propertyId"
                styleInModal="styleInModal"
                isInlineBlock={true}
                width="100%"
                containerWidth="100%"
                floatingLabelText={this.trans(
                  "dropdown-searchforaddress-label"
                )}
                templateFor="property"
                disableEntityCreation={true}
                hideClickThroughLink={true}
                //
                searchText={this.state.address?.displayName ?? ""}
                onSelect={this.onSelectAddress}
                onClear={this.onClearAddress}
              />
            </div>

            {this.state.errors.address ? (
            <div className="coach_newBillSettlement_step_section_content_item_row">

              <div className="coach_newBillSettlement_step_section_content_item_row_error">
                {this.state.errors.address}
              </div>
              </div>
            ) : null}
          </div>
        </div>

        <div className="coach_newBillSettlement_actionButtons">
          <Button variant="contained" onClick={this.onCancel}>
            {this.trans("coach/new-bill-settlement/action-buttons/cancel")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.onNextStep}
            endIcon={<ArrowForwardIosIcon />}
          >
            {this.trans("coach/new-bill-settlement/action-buttons/next")}
          </Button>
        </div>
      </div>
    );
  }
}

export default Address;
